module.exports = __webpack_public_path__ + "img/luisa.899036e5.svg";